module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-01-c04e36b2788d587856239232a5678bac.jpg";